const lazyLoadImage = () => {

    var lazyLoadDelay = 420;
    window.addEventListener("load", function () {
        lazyLoadDelay = 100;
    });
    document.addEventListener("DOMContentLoaded", function () {
        var lazyloadImages = document.querySelectorAll("img.lazy");
        var lazyloadThrottleTimeout;
        function lazyload() {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }
            lazyloadThrottleTimeout = setTimeout(function () {
                lazyloadImages.forEach(function (img: HTMLImageElement) {
                    if (img.classList.contains("lazy-loaded")) {
                        return;
                    }
                    var disToTop = img.getBoundingClientRect().top;
                    var winHeight = document.documentElement.clientHeight;
                    if (disToTop < winHeight) {
                        if (img.dataset.mobileimage && img.dataset.mobileimage.length != 0) {
                            if (document.documentElement.clientWidth < 992) {
                                img.src = img.dataset.mobileimage;
                                img.classList.add('lazy-loaded');
                            } else {
                                img.src = img.dataset.image;
                                img.classList.add('lazy-loaded');
                            }
                        } else {
                            img.src = img.dataset.image;
                            img.classList.add('lazy-loaded');
                        }
                    }
                });
                if(lazyloadImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                }
            }, lazyLoadDelay);
        }
        lazyload();
        document.addEventListener("scroll", lazyload);

    });

};

export {
    lazyLoadImage
};
